import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ISetLicenseLapsedResponse } from "sharedFeatures/sharedServices/Responses/Auth/ISetLicenseLapsedResponse";
import { IErrorResponse } from "sharedFeatures/sharedServices/Responses";
import { ISend } from "sharedFeatures/sharedServices/Responses/FeedBack/ISend";

declare let handleAngularHttpError: any;

@Injectable()
export class CustomerService {
    constructor(private http: HttpClient) { }

    // Update brixxlicense_newapi.customer.LicenseLapsed
    public SetLicenseLapsed(customerId: number, licenseLapsed: boolean) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let data = { customerId, licenseLapsed: (licenseLapsed ? 1 : 0) };

        // Wrap http response with the custom promise to handle error
            const response = this.http.post<string>(window.appPath + 'Auth/SetLicenseLapsed', data, { headers: headers });
            return lastValueFrom(response)
                .then((res: string) => {
                    let data: ISetLicenseLapsedResponse | IErrorResponse = { success: false, errorMessage: '' };

                    if (res && res.length) {
                        if (res.indexOf("error=sessiontimeout") === -1)
                            data = JSON.parse(res);
                    }

                    return data;
                })
                .catch((error: HttpErrorResponse) => {
                    console.error('SetLicenseLapsed error', error);

                    handleAngularHttpError(error);

                    //if we need to transmit the error to a component
                    throw error;
                });
    }

    public sendFeedback(userId: number, choice: string, comment: string, anonymous: boolean) {
        let params = new HttpParams()
            .set('userId', userId)
            .set('choice', choice)
            .set('comment', comment)
            .set('anonymous', anonymous);

        const response = this.http.post<string>(window.coreApiUrl + 'Feedback/Send', null, { params });
        
        return lastValueFrom(response)
            .then((res: string) => {
                let data: IErrorResponse | ISend = { success: false, errorMessage: '' };

                if (res && res.length) {
                    try {
                        data = JSON.parse(res);
                    }
                    catch (e) { }
                }

                return data;
            });
    }
}
